module.exports = __webpack_public_path__ + "img/icon2.49ffe753.png";